import { render, staticRenderFns } from "./SubTopNav.vue?vue&type=template&id=8b33d462&scoped=true&"
import script from "./SubTopNav.vue?vue&type=script&lang=js&"
export * from "./SubTopNav.vue?vue&type=script&lang=js&"
import style0 from "./SubTopNav.vue?vue&type=style&index=0&id=8b33d462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b33d462",
  null
  
)

export default component.exports